// REFACTOR unify
export const operationDisplays = {
  equal: 'is equal to',
  greater: 'is greater than',
  lesser: 'is lesser than',
  before: 'is before',
  after: 'is after',
  insideInterval: 'is inside of interval',
  outsideInterval: 'is outside of interval',
};

export const typeRuleOperationsMap = {
  list: ['equal'],
  integer: ['equal', 'greater', 'lesser', 'insideInterval', 'outsideInterval'],
  boolean: ['equal'],
  float: ['equal', 'greater', 'lesser', 'insideInterval', 'outsideInterval'],
  distance: ['equal', 'greater', 'lesser'],
  speed: ['equal', 'greater', 'lesser'],
  string: ['equal'],
  timestamp: ['before', 'after'],
  date: ['before', 'after'],
  time: ['before', 'after'],
};

export const operators = {
  eq: { display: '=', value: 'eq' },
  gt: { display: '>', value: 'gt' },
  gte: { display: '>=', value: 'gte' },
  lt: { display: '<', value: 'lt' },
  lte: { display: '<=', value: 'lte' },
  ne: { display: '≠', value: 'ne' },
};
const allOperators = Object.keys(operators);
export const typeOperators = {
  list: ['eq', 'ne'],
  integer: allOperators,
  boolean: ['eq'],
  float: allOperators,
  string: ['eq', 'ne'],
  timestamp: allOperators,
  date: allOperators,
  time: allOperators,
  distance: allOperators,
  speed: allOperators,
};
export const operations = {
  setTimestamp: { display: 'Set timestamp', value: 'setTimestamp' },
  changeTo: { display: 'Change to', value: 'changeTo' },
  increment: { display: 'Increment by', value: 'increment' },
  decrement: { display: 'Decrement by', value: 'decrement' },
};

export const typeOperations = {
  list: ['changeTo'],
  integer: ['changeTo', 'increment', 'decrement'],
  boolean: ['Unknown', 'true', 'false'],
  float: ['changeTo', 'increment', 'decrement'],
  string: ['changeTo'],
  timestamp: ['setTimestamp'],
  date: ['setTimestamp'],
  time: ['setTimestamp'],
  distance: ['changeTo', 'increment', 'decrement'],
  speed: ['changeTo', 'increment', 'decrement'],
};

export function getDictionaries(variant) {
  let opsDict, typesDict;
  switch (variant) {
    case 'operation':
      opsDict = operations;
      typesDict = typeOperations;
      break;
    case 'operator':
      opsDict = operators;
      typesDict = typeOperators;
      break;
    default:
      break;
  }
  return { opsDict, typesDict };
}
